import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Text, View, TouchableOpacity, StyleSheet } from 'react-native';
import { moderateScale } from 'react-native-size-matters';

import RadioButton from './RadioButton';
import Theme from '../../theme';

const RadioButtonWithTitle = ({
    isActive,
    title,
    onPress,
    disabled = false,
    showSeparator = false,
    textStyle,
    overrideRadioButtonStyles
}) => (
        <TouchableOpacity onPress={onPress} style={styles.bodyGroupButton}>
            {showSeparator && <View style={styles.verticalSeparator} />}
            <View style={styles.settingCheckboxContainer}>
                <View style={styles.bodyRadioButtonContainer}>
                    <RadioButton
                        disabled={disabled}
                        isSelected={isActive}
                        toggleSelection={onPress}
                        {...overrideRadioButtonStyles}
                    />
                </View>
            </View>
            <View style={styles.textContainer}>
                <Text style={[styles.settingsTitle, disabled && { color: Theme.GREY_MEDIUM }, textStyle]}>{title}</Text>
            </View>
        </TouchableOpacity>
    );

const styles = StyleSheet.create({
    bodyGroupButton: {
        flexDirection: 'row',
    },
    settingCheckboxContainer: {
        paddingTop: 3,
        justifyContent: 'flex-start',
    },
    bodyRadioButtonContainer: {
        marginRight: 15,
    },
    textContainer: {
        justifyContent: 'center',
    },
    settingsTitle: {
        fontSize: moderateScale(13, 1),
        color: Theme.CHARCOAL,
        fontFamily: Theme.Custom500,
        textAlign: 'center'
    },
    verticalSeparator: {
        width: 2,
        marginHorizontal: 10,
        backgroundColor: Theme.GREY_LIGHT,
    },
})


RadioButtonWithTitle.propTypes = {
    isActive: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    onPress: PropTypes.func.isRequired,
};

export default RadioButtonWithTitle;
